import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, tap } from 'rxjs';
import { environment } from 'src/environments/environment';
import { DataService } from './data.service';

@Injectable({
    providedIn: 'root'
})
export class ApplicationDataService {
    data: any;
    private baseUrl = environment.apiBaseUrl;

    private appIdDetails$ = new BehaviorSubject(null)

    constructor(private http: HttpClient, private dataService: DataService) { }

    getApplicationDetails(applicationId: number, isMovingAddress?, promotion?) {
        return this.dataService.getRecord('/api/Application/getApplicationByid/' + applicationId);
    }

    getAllOzowPaymentTransactions(data: any) {
        return this.dataService.post('/api/ozowPayment/getOzowTransactionsDetails', data);
    }

    CheckCreditVet(applicationId: number) {
        return this.dataService.getRecord('/api/Application/CheckCreditVet/' + applicationId);
    }
    getLTETrackingDetails(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/getLTETrackingDetails', searchQuery);
    };

    cancelLTE(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/cancelLTE', searchQuery);
    };

    suspendLTE(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/suspendLTE', searchQuery);
    };

    restoreLTE(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/restoreLTE', searchQuery);
    };


    deleteLTE(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/deleteLTE', searchQuery);
    };


    getApplicationAdditionalQuestions(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getApplicationAdditionalQuestions/' + applicationId);
    }

    getReferenceNo(cusreferenceNo: number) {
        return this.dataService.getRecord('/api/Application/getReferenceNo/' + cusreferenceNo);
    }

    getApplicationDetailsFromApplicationView(applicationid: number) {
        return this.dataService.getRecord('/api/Application/getApplicationDetailsFromApplicationView/' + applicationid);
    }

    getApplicationDetailsFromDeactivatedApplicationView(applicationid: number) {
        return this.dataService.getRecord('/api/Application/GetApplicationDetailsFromDeactivatedApplicationView/' + applicationid);
    }

    getApplicationHistory = function (applicationId: number) {
        return this.dataService.getRecord('/api/Application/getApplicationHistory/' + applicationId);
    }

    getOctotelHistory(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getOctotelHistory/' + applicationId);
    }

    getApplicationComments(applicationId: number) {
        return this.dataService.getRecord('/api/ApplicationNoteMapping/getApplicationComments/' + applicationId);
    }
    getApplicationOldCustomer(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getApplicationOldCustomer/' + applicationId);
    }

    saveApplication = function (application: any) {
        return this.dataService.post('/api/Application/saveApplication', application);
    }

    checkAddressAvailable(application: any) {
        return this.dataService.post('/api/Application/checkAddressAvailable', application)
    }


    editsaveApplication(application: any, customerNumber?: number) {
        return this.dataService.post('/api/Application/editsaveApplication', application);
    }

    getRequestFormPDF(applicationId: number) {
        return this.dataService.getReport('/api/Application/generateRequestFormReport/' + applicationId);
    };
    getShippingAddressDetails(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getShippingAddressDetails/' + applicationId);
    };
    getShippingAddressPDF(applicationId: number) {
        return this.dataService.getReport('/api/Application/printShippingAddress/' + applicationId);
    };

    updateDispatchPending(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/updateDispatchPending/' + applicationId);
    }

    getAdvancedSearch(searchQuery: string) {

        return this.dataService.getRecordWithParams('/api/Application/getAdvancedApplicationsSearch', searchQuery);
    };

    getManageFibreAdvancedSearch(searchQuery: string) {

        return this.dataService.getRecordWithParams('/api/Application/getAdvancedApplicationsSearch', searchQuery);
    };

    getFilterSearch(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/getFilterSearch', searchQuery);
    };

    getManageFibreFilterSearch(searchQuery: string, refresh: boolean) {
        return this.dataService.getDataWithParams('/api/Application/getFilterSearch', searchQuery, refresh);
    };

    // getManageFibreExportData(getData: any) {
    //     return this.dataService.post('/api/Application/getManageFibreExportData', getData);
    // };

    getManageFibreExportData(getData: any) {
        return this.dataService.post('/api/Application/getManageFibreGlobalExportData', getData)
    }


    savePrivateComments(privateComments: string) {

        return this.dataService.post('/api/Application/savePrivateComments/', privateComments);
    }

    deletePrivateComments(notesId: number) {

        //return this.dataService.getRecordWithParams('/api/Application/deletePrivateComments/' + notesId);
    }

    //getCustomerPersonalDetail(customerId) {
    //    return this.dataService.getRecord('/api/customer/getcustomerpersonaldetail/' + customerId);
    //};

    //saveCustomerPersonalDetail(customer) {
    //    return this.dataService.post('/api/customer/savecustomerpersonaldetail', customer);
    //};

    //updateApplicationStatusAsSubmitted(id) {
    //    return this.dataService.post('/api/customer/applicationstatusassubmitted/' + id);
    //};

    //UpdatePreferredPaymentType(customer) {
    //    return this.dataService.post('/api/customer/updatePreferredPaymentType/', customer);
    //};
    //updateCustomerSigned(customer) {
    //    return this.dataService.post('/api/customer/updateCustomerSigned/', customer);
    //};

    //getProductDetailsById(productId) {
    //    return this.dataService.getRecordWithParams('/api/product/GetProductDetailsById/' + productId);
    //};
    getApplicationByCusAddMappingId(customerAddressMappingId: number) {
        return this.dataService.getRecord('/api/Application/GetApplicationBasedOnCustomerAddressMappingId/' + customerAddressMappingId);
    }
    getVumatelPromotionByCusAddMappingId(customerAddressMappingId: number) {
        return this.dataService.getRecord('/api/Application/getVumatelPromotionByCusAddMappingId/' + customerAddressMappingId);
    }
    saveAdditionalQuestions(additionalQuestions: string) {
        return this.dataService.post('/api/Application/SaveAdditionalQuestions', additionalQuestions);
    }

    saveApplicationAddressChange(addressChange: string) {
        return this.dataService.post('/api/Application/saveApplicationAddressChange', addressChange);
    }
    getResellerName(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/getResellerName', searchQuery);
    }
    getSalesRepName(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/getSalesRepName', searchQuery);
    }
    submitProductChangeAcceptanceFromCustomer(application: any) {

        return this.dataService.post('/api/Application/SubmitProductChangeAcceptanceFromCustomer', application);
    }
    sendPhysicalContractMails(applicationId: number) {
        return this.dataService.getRecord('/api/Application/sendPhysicalContractMails/' + applicationId);
    }

    vumatelOrderPendingAerialChange(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/vumatelOrderPendingAerialChange/' + applicationId);
    }

    vumatelOrderApprovedTrenchChange(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/vumatelOrderApprovedTrenchChange/' + applicationId);
    }

    removeRouterChange(applicationId: number) {
        return this.dataService.post('/api/Application/removeRouterChange/', applicationId);
    }

    getApplicationsbyCustomerEmail(vumatelorderid: number) {

        return this.dataService.getRecord('/api/Application/getApplicationsbyCustomerEmail/' + vumatelorderid);
    }

    saveApplicationStatus(applicationid, vumatelorderid: number) {
        return this.dataService.getRecord('/api/Application/saveApplicationStatus/?applicationId=' + applicationid + '&vumatelorderid=' + vumatelorderid);
    }

    getTermsAndConditionsFile(searchQuery: string) {
        return this.dataService.getRecordWithParams('/api/Application/GetTermsAndConditionsFile', searchQuery);

    }

    saveCompleteApplication(searchQuery: string) {
        return this.dataService.post('/api/Application/saveCompleteApplication', searchQuery);

    }

    saveAddressChange(searchQuery: string) {
        return this.dataService.post('/api/Application/saveAddressChange', searchQuery);

    }

    getExistingBankDetails(userId: number) {
        return this.dataService.getRecord('/api/Application/getExistingBankDetails/' + userId);
    };

    getExistingBankDetailsForProfile(userId: number) {
        return this.dataService.getRecord('/api/Application/getExistingBankDetailsForProfile/' + userId + "?isMobileCall=" + false)
            .pipe(tap(r => {
                this.setApplicationDetails(r);
            }));
    };

    setApplicationDetails(r) {
        this.appIdDetails$.next(r)
    }


    getApplicationDetailsObs() {
        return this.appIdDetails$.asObservable();
    }
    productChangeWaterFall(searchQuery: string) {
        return this.dataService.post('/api/Application/productChangeWaterFall/', searchQuery);
    };

    ownRouterDetails(searchQuery: string) {
        return this.dataService.post('/api/Application/ownRouterDetails/', searchQuery);
    }

    reInstateApplication(applicationId: number, result: any) {
        return this.dataService.post('/api/Application/reInstateApplication/' + applicationId, result);
    }

    getSPCentreDetails(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getSPCentreDetails/' + applicationId);
    }

    getFrogFootLinkStatus(applicationId: number) {
        return this.dataService.post('/api/Application/getFrogFootLinkStatus/' + applicationId, this.data);
    }

    suspendSPCenter(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/suspendSPCenter/' + applicationId);
    }

    suspendSPCenterBySecurityProblem(applicationId: number) {
        return this.dataService.post('/api/Application/suspendSPCenterBySecurityProblem/' + applicationId, null);
    }

    revokeSPCenter(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/revokeSPCenter/' + applicationId);
    }

    bulkSuspendSPCenter(searchQuery: string) {
        return this.dataService.post('/api/Application/bulkSuspendSPCenter', searchQuery);
    };

    bulkRevokeSPCenter(searchQuery: any) {
        return this.dataService.post('/api/Application/bulkRevokeSPCenter', searchQuery);
    };

    getAdvancedSearchWithAll(searchQuery: string) {

        return this.dataService.getRecordWithParams('/api/Application/getAdvancedApplicationsSearchWithAll', searchQuery);
    };

    cancelSPRequestApplication(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/cancelSPRequestApplication/' + applicationId);
    }

    checkDebitFormOnceOffPaid(applicationId: number) {

        return this.dataService.getRecord('/api/Application/checkDebitFormOnceOffPaid/' + applicationId);
    };

    saveApplicationOnceOffPaid(searchQuery: string) {

        return this.dataService.post('/api/Application/saveApplicationOnceOffPaid/', searchQuery);
    };
    saveApplicationOnceOffPaidForCreditCard(searchQuery: string) {

        return this.dataService.post('/api/Application/saveApplicationOnceOffPaidForCreditCard/', searchQuery);
    };
    saveBNumber(searchQuery: string) {

        return this.dataService.post('/api/Application/saveBNumber/', searchQuery);
    };
    approveBNumber(applicationId: string) {
        return this.dataService.postWithQueryParms('/api/Application/approveBNumber/' + applicationId);
    }
    rejectBNumber(applicationId: string) {
        return this.dataService.postWithQueryParms('/api/Application/rejectBNumber/' + applicationId);
    }
    getApplicationIsOpenServeOnt(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/getApplicationIsOpenServeOnt/' + applicationId);
    }
    saveBankNotVerified(applicationId: number) {
        return this.dataService.post('/api/Application/saveBankNotVerified/', applicationId);
    }
    checkBankVerified(applicationId: number) {
        return this.dataService.getRecord('/api/Application/checkBankVerified/' + applicationId);
    }
    saveBankIsVerified(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/saveBankIsVerified/' + applicationId);
    }

    getReferenceNumberByAppId(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getReferenceNumberByAppId/' + applicationId);
    }
    paymentNotificationForWANDowngrade(applicationId: number) {
        return this.dataService.getRecord('/api/Application/paymentNotificationForWANDowngrade/' + applicationId);
    }
    getIsChangeOFService(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getIsChangeOFService/' + applicationId);
    }
    saveIsChangeOFService(applicationId: number) {
        return this.dataService.post('/api/Application/saveIsChangeOFService/', applicationId);
    }
    getServiceChangeRequestIdByAppId(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getServiceChangeRequestIdByAppId/' + applicationId);
    }
    clearApplicationOnceOffPaid(applicationId: number) {
        return this.dataService.post('/api/Application/clearApplicationOnceOffPaid/', applicationId);
    }
    saveVumatelProductMapping(searchQuery: string) {
        return this.dataService.post('/api/Application/saveVumatelProductMapping/', searchQuery);
    }
    saveAccountIdByWorkOrderReference(applicationId: number, workOrderRef: any) {
        const url = `/api/Application/saveAccountIdByWorkOrderReference/?applicationId=${applicationId}&workOrderRef=${encodeURIComponent(workOrderRef)}`;
        return this.dataService.post(url, {});
    }


    saveVumatelAPIOrderNumber(applicationId: number, vumatelOrderNo: number) {
        return this.dataService.postWithQueryParms('/api/Application/saveVumatelAPIOrderNumber/?applicationId=' + applicationId + '&vumatelOrderNo=' + vumatelOrderNo);
    }

    saveReportSearch(searchQuery: any) {
        return this.dataService.post('/api/Report/saveReportSearch/', searchQuery);
    }

    approveRecurringInvoice(searchQuery: string) {
        return this.dataService.post('/api/Report/approveRecurringInvoice/', searchQuery);
    }

    getRecurringApplication(referenceNumber: number) {
        return this.dataService.getRecord('/api/Application/getRecurringApplication/' + referenceNumber);
    }

    recurringNewCost(searchQuery: string) {
        return this.dataService.post('/api/Application/recurringNewCost/', searchQuery);
    }
    // getOldproduct(applicationId:number) {
    //     return this.dataService.getRecord('/api/Application/getOldproduct/' + applicationId);
    // }
    checkResellerCustomer() {
        return this.dataService.getRecord('/api/Application/checkResellerCustomer');
    }
    checkResellerCustomerWithApplicationId(applicationId: number) {
        return this.dataService.getRecord('/api/Application/checkResellerCustomerWithApplicationId/' + applicationId);
    }
    // getConnectionByApplicationId(applicationId:number) {
    //     return this.dataService.getRecord('/api/Application/getConnectionByApplicationId/' + applicationId);
    // }
    getResellerProductDetail(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getResellerProductDetail/' + applicationId);
    }

    updateSchoolProduct(schoolPackageDetails: string) {
        return this.dataService.post('/api/Application/updateSchoolProduct', schoolPackageDetails);
    }

    saveVumatelInstallationSchedule(schoolPackageDetails: number) {
        return this.dataService.post('/api/Application/saveVumatelInstallationSchedule/', schoolPackageDetails);
    }

    saveVumatelInstallationCompleted(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/saveVumatelInstallationCompleted/' + applicationId);
    }

    // checkEnquiryStatus(applicationId:number) {
    //     return this.dataService.getRecord('/api/Report/checkEnquiryStatus/' + applicationId);
    // }

    // riskEnquiryStatusMailToCustomer(applicationId:number) {
    //     return this.dataService.getRecord('/api/Application/riskEnquiryStatusMailToCustomer/' + applicationId);
    // }

    // updateWayBillNumber(params:any) {
    //     return this.dataService.post('/api/Application/updateWayBillNumber', params);
    // }

    // getCompuScanEnquiryByApplicationId(applicationId:number) {
    //     return this.dataService.getRecord('/api/Application/getCompuScanEnquiryByApplicationId/' + applicationId);
    // }

    // getPPPOEDetails(connectionId:number) {
    //     return this.dataService.getRecord('/api/Application/getPPPOEDetails/' + connectionId);
    // }

    // updatePPPOEPassword(params:any) {
    //     return this.dataService.post('/api/Application/updatePPPOEPassword', params);
    // }

    // getAddressChangeCancellation(applicationId:number) {
    //     return this.dataService.getRecord('/api/Application/getAddressChangeCancellation/' + applicationId);
    // }

    // approveAddressChange(applicationId:number) {
    //     return this.dataService.getRecord('/api/Application/approveAddressChange/' + applicationId);
    // }

    activateServiceSuspendApplication(applicationId: number) {
        return this.dataService.postWithQueryParms('/api/Application/activateServiceSuspendApplication/' + applicationId);
    }
    updateLineNumber(params: any) {
        return this.dataService.post('/api/Application/updateLineNumber', params);
    }

    saveAmendDeliveryAddress(address: string) {
        return this.dataService.post('/api/Application/saveAmendDeliveryAddress', address);
    }

    saveCollection(collection: any) {
        return this.dataService.post('/api/Application/saveCollection', collection);
    }

    saveRevokeCollection(collection: any) {
        return this.dataService.post('/api/Application/saveRevokeCollection', collection);
    }

    saveLegalCollection(legalCollection: any) {
        return this.dataService.post('/api/Application/saveLegalCollection', legalCollection);
    }


    saveVumatelStatus(vumatelStatus: any) {
        return this.dataService.post('/api/Application/saveVumatelStatus', vumatelStatus);
    }
    getServiceActivationNumber(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getServiceActivationNumber/' + applicationId);
    }

    getcancelreason() {
        return this.dataService.getRecord('/api/ServiceChangeRequest/getCancellationReasonsForAllFNO');
    }

    // getdebitDate(applicationId:number:number) {
    //     return this.dataService.getRecord('/api/Application/getdebitDate/' + applicationId);
    // }

    // getResellerInformation(applicationId:number) {
    //     return this.dataService.getRecord('/api/Application/getResellerInformation/' + applicationId);
    // }

    getCustomerDiscountPercentage(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getCustomerDiscountPercentage/' + applicationId);
    }

    getServiceCancellationApplicationViewByid(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getServiceCancellationApplicationViewByid/' + applicationId);
    }

    getServiceChangeApplicationViewByid(applicationId: number) {
        return this.dataService.getRecord('/api/Application/getServiceChangeApplicationViewByid/' + applicationId);
    }

    getResellerCodeByUserId(userId, applicationId: number) {
        return this.dataService.getRecord('/api/Application/getResellerCodeByUserId/' + userId + '/' + applicationId);
    }

    saveCustomerAgreedInstallation(data: any) {
        return this.dataService.post('/api/Application/saveCustomerAgreedInstallation', data);
    }

    saveOctotelAPIOrderNumber(applicationId: number, octotelOrderNo: number) {
        return this.dataService.postWithQueryParms(
            `/api/Application/saveOctotelAPIOrderNumber/?applicationId=${applicationId}&octotelOrderNo=${octotelOrderNo}`
        );
    }
    setWorkinProgress(applicationId: number) {
        return this.dataService.getRecord('/api/Application/setWorkinProgress/' + applicationId);
    }

    getFrogFootActionAequired() {
        return this.dataService.getRecord('/api/Application/getFrogFootActionAequired');
    }

    getSingleFrogFootComment(frogFootLinkLabel: any) {
        return this.dataService.getRecord('/api/Application/getSingleFrogFootComment/' + frogFootLinkLabel);
    }

    saveFrogFootComment(data: any) {
        return this.dataService.post('/api/Application/getSingleFrogFootComment/', data);
    }

    // generatePayments(document:any) {
    //     return this.dataService.post('/api/debitForm/generatePayments',document);
    // }

    saveSalesResellerAuditTrail(oPostData: any) {
        return this.dataService.post('/api/Application/saveSalesResellerAuditTrail', oPostData);
    }


    // getApplicationDropDownForCourierTracking() {
    //     return this.dataService.getRecord('/api/Application/ApplicationDropDownForCourierTracking');
    // }

    // getCourierTracking(wayBillNo:number) {
    //     return this.dataService.getRecord('/api/Application/CourierTracking/' + wayBillNo);
    // }

    getCourierWaybill(wayBillNo: number) {
        return this.dataService.getRecord('/api/Application/CourierWaybill/' + wayBillNo);
    }

    saveLinkAddressChange(oPostData: any) {
        return this.dataService.post('/api/Application/LinkAddressChange', oPostData);
    }

    saveIsownRouterStatus(applicationId: number, ownRouterStatus: any) {
        return this.dataService.post('/api/Application/saveIsownRouterStatus/?applicationId=' + applicationId + '&OwnRouterStatus=' + ownRouterStatus, null);
    }

    getUserHaveOnlyPendingApplication() {
        return this.dataService.getRecord('/api/Application/userHaveOnlyPendingApplication');
    }

    getApplicationForTraceRemovalOperation(ReferenceNo: number) {
        return this.dataService.getRecord('/api/Application/getApplicationForTraceRemovalOperation/' + ReferenceNo);
    }

    saveRemovalOperation(requestData: any) {
        return this.dataService.post('/api/Application/saveRemovalOperation', requestData);
    }
    changeApprovedToSpRequest(applicationId: number) {
        return this.dataService.getRecord('/api/Application/changeApprovedToSpRequest/' + applicationId);
    }
    approveRecurringInvoiceValidation() {
        return this.dataService.getRecord('/api/Report/approveRecurringInvoiceValidation');
    }
    getPPPOEdetails(connectionId: number, applicationReferenceNumber: number) {
        return this.dataService.getRecord('/api/Application/GetPPPOEdetail/' + connectionId + '/' + applicationReferenceNumber);
    }
    // //getPPPOEdetails(applicationId) {
    // //    return this.dataService.getRecord('/api/Application/GetPPPOEdetail/' + applicationId);
    // //}
    updatePPPOEdetails(requestData: any) {
        return this.dataService.post('/api/Application/updatePPPOEdetails', requestData);
    }
    accAndRejCancelStatus(applicationId: number, actionInfo: any) {
        return this.dataService.getRecord('/api/Application/acceptCancelStatus/' + applicationId + '/' + actionInfo);
    }

    // getLocationRefByAppID(applicationId:number) {
    //     return this.dataService.getRecord('/api/Application/getLocationRefByAppID/' + applicationId);
    // }

    getAppNoFromEmailFrmApprovedAppLst = function (userID: number) {
        return this.dataService.getRecord('/api/Application/GetAppNoFromEmail/' + userID);
    }
    getSuspensionGridData = function () {
        return this.dataService.getRecord('/api/Application/SuspenionGrid');
    }
    getApplicationServiceChangeHistory(data: any) {
        return this.dataService.getRecord('/api/Application/getApplicationServiceChangeHistory/' + data);
    }
    Futiredatestatus(applicationId, applicationstatus) {
        return this.dataService.getRecord('/api/Application/Futiredatestatus/' + applicationId + '/' + applicationstatus);
    }
    LinkEvotelWithoutInstallation(requestData: any) {
        return this.dataService.post('/api/Application/LinkEvotelWithOutInstallation/', requestData);
    }

    getCollectionPDF(applicationId: number) {
        return this.dataService.getReport('/api/Application/PrintCollectionPDF/' + applicationId);
    };

    addOrUpdateSuspension(requestData: any) {
        return this.dataService.post('/api/ManageSuspension/addOrUpdateSuspensionDetails', requestData);
    }

    getUpcomingScheduledList(searchQuery: any) {
        return this.dataService.getRecordWithParams('/api/ManageSuspension/getUpcomingScheduledList', searchQuery)
    }
    getSuspensionHistoryList(requestData: any) {
        return this.dataService.getRecordWithParams('/api/ManageSuspension/getSuspensionHistoryList', requestData);
    }
    getFilteredSuspensionHistoryList(requestData: any) {
        return this.dataService.post('/api/ManageSuspension/getFilteredSuspensionHistoryList', requestData);
    }

    getSuspensionDashboardCount(month: string) {
        return this.dataService.getRecord('/api/ManageSuspension/getSuspensionDashboardCount/' + month);
    }
    
    deleteSuspension(manageSuspensionId: number) {
        return this.dataService.getRecord('/api/ManageSuspension/deleteSuspension/' + manageSuspensionId);
    };

    startSuspensionProcess(manageSuspensionId: string) {
        return this.dataService.getRecord('/api/ManageSuspension/StartSuspensionProcess/' + manageSuspensionId);
    }
    
    paymentStatusUpdateLte(ApplicationId: any, ApplicationStatus: any) {
        return this.dataService.getRecord(`/api/LTE/paymentStatusUpdateLte/${ApplicationId}/${ApplicationStatus}`)
    }
    exportSessionLogData(searchQuery: string) {
        return this.dataService.getRecord(
            `/api/spcenter/GetSessionLogsExportData?searchQuery=${encodeURIComponent(searchQuery)}`
        );
    }
    staticIPAssign(AppId) {
        return this.dataService.getRecord(`/api/Application/staticIPAssign/${AppId}`)
    }

    updateApplicationStatusAndAcceptShopOrder(appId: number) {
        return this.dataService.getRecord('/api/Application/updateApplicationStatusAndAcceptShopOrder?appId=' + appId);
    }

    moveToNewApp(AppId) {
        return this.dataService.getRecord('/api/application/moveToNewApplication/?applicationId=' + AppId);
    }
}   
